// removed by extract-text-webpack-plugin
module.exports = {"root":"Editor__root___DxXGY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Car/Editor/Editor.scss
// module id = 979
// module chunks = 0